export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Information here',
  headline: 'Your website here for all to see',
  description:
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet omnis quam incidunt tempore minus saepe distinctio!',
  buttonLabel: 'Get Started',
  imgStart: false,
  img: require('../../images/New SVG-1.png'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false,
}

export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Information Here',
  headline: 'Login to your account at any time',
  description:
    'We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.',
  buttonLabel: 'Learn More',
  imgStart: true,
  img: require('../../images/New SVG-2.png'),
  alt: 'Piggybank',
  dark: false,
  primary: false,
  darkText: true,
}

export const homeObjThree = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Join our Team',
  headline: 'You website for the world to see',
  description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
  buttonLabel: 'Start Now',
  imgStart: false,
  img: require('../../images/New SVG-3.png'),
  alt: 'Papers',
  dark: false,
  primary: false,
  darkText: true,
}
